import { EVENT_OPEN } from "manifest-bridge-core/src/events";

const sendOpen = (message: string, origin: string) => {
  window.parent.postMessage(
    {
      type: EVENT_OPEN,
      data: message,
    },
    origin,
  );
};

export default sendOpen;
